<template>
  <nav class="dotcom_breadcrumb" data-track-as="breadcrumb">
    <ul v-if="items.length > 0" class="dotcom_breadcrumb_navigation_links">
      <li
        v-for="(navigationLink, index) in items"
        :key="index"
        class="dotcom_breadcrumb_navigation_links__list"
      >
        <a
          class="dotcom_breadcrumb_navigation_links__link"
          :href="navigationLink.href"
          rel="noopener"
        >
          <dotcom-icon
            v-if="items.length === 1"
            name="arrow-right"
            art="light"
            rotation="180"
          />
          {{ navigationLink.title }}
        </a>

        <span
          v-if="index < items.length - 1"
          class="dotcom_breadcrumb_navigation_links__caret_container"
        >
          <dotcom-icon
            name="chevron-right"
            art="regular"
            color="--c-primary-neutral-1"
          />
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
import { computed, getCurrentInstance } from '@vue/composition-api'
import isString from 'lodash/isString'

export default {
  name: 'DotcomBreadcrumb',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    navigationLinks: {
      type: [String, Array],
      default() {
        return []
      },
    },
  },

  setup(props) {
    const root = getCurrentInstance().proxy
    const links = isString(props.navigationLinks)
      ? JSON.parse(props.navigationLinks)
      : props.navigationLinks
    const items = computed(() => {
      if (!root.$mq['xs+'] && !root.$mq.xs) {
        return links.slice(-1)
      }
      return links
    })

    return {
      items,
    }
  },
}
</script>

<style lang="postcss">
.dotcom_breadcrumb {
  @mixin antiBase;

  display: block;
  padding: 25px 0;

  .dotcom_breadcrumb_navigation_links {
    display: flex;
    list-style: none;
  }

  .dotcom_breadcrumb_navigation_links__list {
    display: flex;
    align-items: center;
    /* the min height is the same as the icon size so that it aligns vertically */
    min-height: 30px;

    .dotcom_breadcrumb_navigation_links__link {
      display: flex;
      align-items: center;
      gap: var(--spacing-1);
      cursor: pointer;
      font-size: 18px;
      font-weight: 400;
      color: var(--c-primary-neutral-1);

      &:hover {
        color: var(--c-primary-color-2);
      }
    }
  }

  .dotcom_breadcrumb_navigation_links__caret_container {
    font-size: 15px; /* Overwrite the magazine wide style for li  */
    margin: 0 var(--spacing-2);
  }
}

/*                       */
/* Mobile specific style */
/*                       */
@media (max-width: 490px) {
  .dotcom_breadcrumb {
    padding: 15px 0;

    .dotcom_breadcrumb_navigation_links__list {
      .dotcom_breadcrumb_navigation_links__link {
        font-size: 16px;
      }
    }
  }
}
</style>

<style scoped>
.dotcom_breadcrumb_navigation_links__link {
  & >>> .dotcom-icon {
    font-size: 12px;
  }
}

.dotcom_breadcrumb_navigation_links__caret_container >>> .dotcom-icon {
  font-size: 12px;
}
</style>
